import {NAME} from './constants'

export const  GET_QR_CODE = NAME + '_GET_QR_CODE';


